import React from "react";

import { loadModules } from "@esri/react-arcgis";
const options = { url: "https://js.arcgis.com/3.29/" };
const app = {};

class MapEsri extends React.Component {
  static instanceCount = 0;
  constructor(props) {
    super(props);
    var me = this;
    MapEsri.instanceCount++;
    me.instanceId = MapEsri.instanceCount;
  }
  renderMap() {
    return;
  }
  componentDidMount() {
    let me = this;
    loadModules(
      [
        "esri",
        "esri/map",
        "esri/graphic",
        "esri/tasks/query",
        "esri/layers/ArcGISDynamicMapServiceLayer",
        "esri/layers/FeatureLayer",
        "esri/symbols/SimpleFillSymbol",
        "esri/symbols/SimpleLineSymbol",
        "esri/Color",
        "esri/geometry/webMercatorUtils",
        "esri/dijit/PopupTemplate",
        "esri/layers/WMSLayer",
        "esri/layers/WMSLayerInfo",
        "esri/layers/DynamicLayerInfo",
        "esri/geometry/Extent",
        "esri/layers/KMLLayer",
        "esri/dijit/Basemap",
        "esri/dijit/BasemapLayer",
        "esri/dijit/BasemapGallery",
        "esri/dijit/Legend",
        "dojo/_base/array",
        "esri/request",
        "dojo/Deferred",
        "esri/geometry/Circle",
        "esri/InfoTemplate"
      ],
      options
    ).then(
      ([
        esri,
        Map,
        Graphic,
        Query,
        DynamicLayer,
        FeatureLayer,
        SimpleFillSymbol,
        SimpleLineSymbol,
        Color,
        webMercatorUtils,
        PopupTemplate,
        WMSLayer,
        WMSLayerInfo,
        DynamicLayerInfo,
        Extent,
        KMLLayer,
        Basemap,
        BasemapLayer,
        BasemapGallery,
        Legend,
        array,
        request,
        Deferred,
        Circle,
        InfoTemplate
      ]) => {
        app.Query = Query;
        app.webMercatorUtils = webMercatorUtils;
        app.layer_config = esri.layers.FeatureLayer.SELECTION_NEW;
        app.FeatureLayer = FeatureLayer;
        app.layer_config_auto = FeatureLayer.MODE_AUTO;
        app.PopupTemplate = PopupTemplate;
        app.Graphic = Graphic;
        app.PopupTemplate = PopupTemplate;
        app.WMSLayer = WMSLayer;
        app.WMSLayerInfo = WMSLayerInfo;
        app.DynamicLayer = DynamicLayer;
        app.DynamicLayerInfo = DynamicLayerInfo;
        app.Extent = Extent;
        app.KMLLayer = KMLLayer;
        app.Basemap = Basemap;
        app.BasemapLayer = BasemapLayer;
        app.BasemapGallery = BasemapGallery;
        app.Legend = Legend;
        app.array = array;
        app.request = request;
        app.Deferred = Deferred;
        app.InfoTemplate = InfoTemplate;
        app.SimpleFillSymbol = SimpleFillSymbol;
        app.SimpleLineSymbol = SimpleLineSymbol;
        app.Color = Color;
        var highlightSymbol = new SimpleFillSymbol(
          SimpleFillSymbol.STYLE_SOLID,
          new SimpleLineSymbol(
            SimpleLineSymbol.STYLE_SOLID,
            new Color([189, 191, 192]),
            1.2
          ),
          new Color([125, 125, 125, 0.25])
        );
        app.highlightSymbol = highlightSymbol;
        app.map = new Map("map-component-view", {
          basemap: "satellite",
          minZoom: 3,
          maxZoom: 19,
          center: [-75.074387, -10.39665],
          zoom: 6,
          showLabels: true
        });

        app.map.on("load", function () {
          app.map.graphics.enableMouseEvents();
          var circleSymb = new app.SimpleFillSymbol(
            app.SimpleFillSymbol.STYLE_NULL,
            new app.SimpleLineSymbol(
              app.SimpleLineSymbol.STYLE_SHORTDASHDOTDOT,
              new app.Color([105, 105, 105]),
              2
            ), new app.Color([255, 255, 0, 0.25])
          );
          /*app.map.on("click", function (evt) {
            var circle = new Circle({
              center: evt.mapPoint,
              geodesic: true,
              radius: 10,
              radiusUnit: "esriMiles"
            });
            app.map.graphics.clear();
            var graphic = new Graphic(circle, circleSymb);
            app.map.graphics.add(graphic);
            console.log("evt", evt);

            var latitude = evt.mapPoint.getLatitude();
            var longitude = evt.mapPoint.getLongitude();
            app.map.infoWindow.setTitle("Coordinates");
            app.map.infoWindow.setContent(
              "latitud/longitud : " + latitude.toFixed(2) + ", " + longitude.toFixed(2) +
              "<br>screen x/y : " + evt.screenPoint.x + ", " + evt.screenPoint.y
            );
            app.map.infoWindow.show(evt.mapPoint, app.map.getInfoWindowAnchor(evt.screenPoint));
          });*/

          app.load = true;
          if (me.props.layerBaseName) {
            app.basemapGallery = new BasemapGallery(
              {
                showArcGISBasemaps: true,
                map: app.map
              },
              me.props.layerBaseName
            );
            app.basemapGallery.startup();
          }
        });
      },
      error => {
        // eslint-disable-next-line no-console
      }
    );
  }
  getMapContainerId() {
    return "map-geo-" + this.instanceId;
  }
  getLegendContainerId() {
    return "map-legend-" + this.instanceId;
  }
  addLayerKml(layer, record) {
    let layerData = new app.KMLLayer(record.url);
    app[layer] = layerData;
    app.map.addLayer(app[layer]);
  }
  addLayerWms(layer, record) {
    let layerData = new app.WMSLayer(record.url, {
      id: layer,
      resourceInfo: {
        extent: new app.Extent(0, 0, 0, 0, {
          wkid: 4326
        }),
        layerInfos: [
          new app.WMSLayerInfo({
            name: record.layerName,
            title: "Capa",
            showPopup: true,
            queryable: true
          })
        ],
        format: "png",
        version: "1.1.1",
        bgcolor: "ffffff"
      },
      visibleLayers: [record.layerName]
    });
    app[layer] = layerData;
    app.map.addLayer(app[layer]);
  }
  addLayerWfs(layer, record) {
    let template = new app.PopupTemplate({
      title: record.label,
      fieldInfos: [{ fieldName: "*", visible: true }]
    });
    let layerData = new app.FeatureLayer(record.url, {
      id: layer,
      layerId: layer,
      name: layer,
      infoTemplate: template,
      mode: app.layer_config_auto,
      showAttribution: true,
      outFields: ['*']
    });
    app[layer] = layerData;
    app.map.addLayer(app[layer]);
    if (this.props.legendName &&
      document.getElementById(this.props.legendName).childElementCount == 0) {
      app.legend = new app.Legend({
        map: app.map,
        layerInfos: [{
          layer: layerData,
          title: record.label
        }]
      }, this.props.legendName);
      app.legend.startup();
    } else {
      app.legend.layerInfos.push({
        layer: layerData,
        title: record.label
      });
      app.legend.layers.push(layerData);
      app.legend.refresh();
    }
  }
  render() {
    let me = this;
    if (app.load && this.props.dataLayer.length > 0) {
      this.props.dataLayer.forEach(function (record, j) {
        let layer = record.id;
        if (record.init) {
          if (record.type === "wms") {
            me.addLayerWms(layer, record);
          } else if (record.type === "wfs") {
            me.addLayerWfs(layer, record);
          } else {
            me.addLayerKml(layer, record);
          }
        } else {
          if (record.type === "wms") {
            if (!record.checked) {
              if (app[layer]) {
                app[layer].hide();
              }
            } else {
              if (!app[layer]) {
                me.addLayerWms(layer, record);
              } else {
                app[layer].show();
              }
            }
          } else if (record.type === "wfs") {
            if (!record.checked) {
              if (app[layer]) {
                app[layer].hide();
              }
            } else {
              if (!app[layer]) {
                me.addLayerWfs(layer, record);
              } else {
                app[layer].show();
              }
            }
          } else {
            if (record.type === "kml") {
              if (!record.checked) {
                if (app[layer]) {
                  app[layer].hide();
                }
              } else {
                if (!app[layer]) {
                  me.addLayerKml(layer, record);
                } else {
                  app[layer].show();
                }
              }
            }
          }
        }
      });
    }
    return <div >{this.renderMap()}</div>;
  }
}
export default MapEsri;
